var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9876 15.6391H6.16882",
    stroke: "#898B8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9876 11.0958H6.16882",
    stroke: "#898B8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1541 6.56207H6.16882",
    stroke: "#898B8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5876 1.01025H6.36635C5.69901 0.978204 5.03125 1.06568 4.40123 1.26769C3.7712 1.46969 3.19126 1.78225 2.69454 2.18752C2.19781 2.59279 1.79405 3.08281 1.50632 3.6296C1.21859 4.17638 1.05252 4.7692 1.01762 5.37419C1.00427 5.5906 1.00427 5.80752 1.01762 6.02393V15.998C0.961955 16.6033 1.03849 17.2126 1.24283 17.7911C1.44718 18.3696 1.77534 18.9059 2.20854 19.3693C2.64173 19.8327 3.17146 20.2142 3.76743 20.4918C4.36339 20.7695 5.01389 20.9379 5.68171 20.9874C5.93097 21.0044 6.18128 21.0044 6.43053 20.9874H15.6303C16.3553 21.0189 17.0794 20.9103 17.7545 20.6687C18.4296 20.4272 19.0403 20.0582 19.5461 19.5864C20.052 19.1145 20.4413 18.5506 20.6884 17.9319C20.9354 17.3132 21.0345 16.654 20.9791 15.998V6.01908C21.0456 5.35662 20.953 4.68896 20.7075 4.06209C20.462 3.43523 20.0694 2.86407 19.557 2.38798C19.0445 1.91188 18.4243 1.54217 17.739 1.30433C17.0537 1.06648 16.3197 0.966147 15.5876 1.01025Z",
    stroke: "#898B8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiary);
export default __webpack_public_path__ + "static/media/diary.5c088cda9fd83c72e0438b5ad05aec79.svg";
export { ForwardRef as ReactComponent };